import { Stack } from '@mui/material';

import NotificationHeaderCard from 'src/components/notification-header-card/notification-header-card';

type Props = {
  children: React.ReactNode;
};

export default function NotificationHeaderLayout({ children }: Props) {
  return (
    <Stack height='100%'>
      <NotificationHeaderCard />
      <Stack height='100%'>{children}</Stack>
    </Stack>
  );
}
